<template>
  <div class="background-01">
  
    <v-layout row wrap>
  
      <v-flex xs12 sm10>
  
        <ui-title-red textTitle="Metas"></ui-title-red>
  
      </v-flex>
  
      <v-flex xs12 sm2 hidden-xs-only>
  
        <image-app :imaSize="200" imaSrc="design/banco1-1-3-2" imaAlt=""></image-app>
  
      </v-flex>
  
      <v-flex xs12 class="text-xs-center">
  
        <ui-simple-lsc :vidTittle="'Las metas'" videoEmbed="ADMINISTRACIONDINERO04LasMetas.mp4"></ui-simple-lsc>
  
      </v-flex>
  
      <v-layout row wrap justify-center>
  
        <v-flex xs12 sm5 class="animated fadeInUp">
  
          <image-app :imaSize="300" imaSrc="contenido/diapositiva_5" imaAlt="Tres dardos en el centro de una diana"></image-app>
  
        </v-flex>
  
        <v-flex xs12 sm5 class="aligner animated fadeInRight dura_1">
  
          <p class="adorn-bottom">
  
            Todas las personas deberían ponerse <strong>objetivos</strong> o <strong>metas</strong> frente a la administración del dinero a corto, mediano y largo plazo, y trabajar para cumplirlas.<br><br> El <strong>ahorro</strong> y la correcta <strong>administración del dinero</strong>          permiten alcanzar dichas metas. Para lograrlas de una manera más fácil, estas deben ser claras y estar bien definidas.
  
          </p>
  
        </v-flex>
  
      </v-layout>
  
    </v-layout>
  
  </div>
</template>


<script>
  export default {
  
    props: {
  
      modName: {
  
        type: String,
  
        required: false
  
      }
  
    },
  
    data() {
  
      return {};
  
    },
  
    mounted() {
  
      this.$store.commit("nextShow", true);
  
    }
  
  };
</script>


// WEBPACK FOOTER //
// davivienda-04.vue?001b92c2